import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import ImageLoader from "../../../Common/ImageLoader";
import * as actionTypes from "../../../../store/actions/actionTypes";

const CompetitorBoxNew = props => {
  const getClassByVendorType = competitor => {
    if (competitor.is_sponsored) {
      return "ribbon ribbon-top-right sponsored";
    } else {
      switch (competitor.type) {
        case "verified":
          return "ribbon ribbon-top-right verified";
        case "normal":
          return "";
        case "premium":
          return "ribbon ribbon-top-right premium";
        case "sponsored":
          return "ribbon ribbon-top-right sponsored";
        default:
          return "";
      }
    }
  };

  const getRibbonByVendorType = competitor => {
    if (competitor.is_sponsored) {
      return (
        <span>
          <div className="ribbonTxt">SPONSORED</div>
        </span>
      );
    } else {
      switch (competitor.type) {
        case "verified":
        case "normal":
          return "";
        case "premium":
          return (
            <span>
              <div className="ribbonTxt">PREMIUM</div>
            </span>
          );
        case "sponsored":
          return (
            <span>
              <div className="ribbonTxt">SPONSORED</div>
            </span>
          );
        default:
          return "";
      }
    }
  };

  return (
    <div className="competitor_block">
      <div className="top_header_text_block">
        <span className="header_txt">
          Don't see enough customer references?
        </span>
        {!!props.vendorCommon &&
        !!props.vendorCommon.competitors &&
        props.vendorCommon.competitors.length > 0
          ? `Check out these ${props.vendorCommon.name} competitors`
          : null}
      </div>
      <div className="competitor_box">
        <ul>
          {!!props.vendorCommon &&
          !!props.vendorCommon.competitors &&
          props.vendorCommon.competitors.length > 0 ? (
            props.vendorCommon.competitors.map(competitor => (
              <li
                onClick={e => {
                  e.preventDefault();
                  props.history.push(competitor.profile_url);
                }}
              >
                {competitor.type === "verified" && (
                  <div className="verified-badge">
                    <img src="/images/verified-badge.webp" alt="" />
                  </div>
                )}
                <ul>
                  {competitor.type !== "verified" && (
                    <div className={getClassByVendorType(competitor)}>
                      {getRibbonByVendorType(competitor)}
                    </div>
                  )}
                  <li>
                    <div className="left">
                      <div className="logo">
                        <ImageLoader
                          image={competitor.logo}
                          fallbackImage={"/static/images/FC-Generic-Logo.webp"}
                        />
                      </div>
                    </div>
                    <div className="right">
                      <span className="name">{competitor.name}</span>
                      <div className="customers_Num">
                        <span className="number">
                          {competitor.reviews_count}
                        </span>
                        Customer References
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            ))
          ) : (
            <div className="no_active_competitor">
              <div className="heading_txt">
                No Companies found in this Category
              </div>
              <p>
                Browse for another company with more unlocked references and
                customer reference content.
              </p>
              <div className="btn_select_category">
                <Link to="/software">Select A New Category</Link>
              </div>
            </div>
          )}
        </ul>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    setVendorDirectoryLoadedStatusFalse: () =>
      dispatch({ type: actionTypes.SET_VENDOR_DIR_DATA_LOADED_FALSE }),
  };
};

const CompetitorBoxNewWithRouter = withRouter(CompetitorBoxNew);

export default connect(null, mapDispatchToProps)(CompetitorBoxNewWithRouter);
